export const GET_TASKS = 'Get_Tasks';